import React, {useEffect, useState, useMemo} from 'react'
import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  flexRender,
} from '@tanstack/react-table'
import {adaptarColumnas} from '../utils/adaptarColumnasTabla'

const TablaDinamica = ({
  titulo,
  data,
  columns,
  paginacion = false,
  fondoTabla = 'bg-cendiatra-verde-7',
  bordeInferior = 'border-b border-b-cendiatra-gris-placeholder',
  numeroFilas = 10,
}) => {
  const columnasAdaptadas = useMemo(() => adaptarColumnas(columns), [columns])

  const table = useReactTable({
    columns: columnasAdaptadas,
    data,
    getCoreRowModel: getCoreRowModel(),
    ...(paginacion && {
      getPaginationRowModel: getPaginationRowModel(),
      initialState: {
        pagination: {pageIndex: 0, pageSize: numeroFilas},
      },
    }),
    enableRowSelection: true,
    enableMultiRowSelection: false,
  })

  const pageIndex = table.getState().pagination?.pageIndex ?? 0
  const pageCount = table.getPageCount()
  const pageOptions = useMemo(
    () => Array.from({length: pageCount}, (_, i) => i),
    [pageCount]
  )

  const [numeroInicio, setNumeroInicio] = useState(0)
  const [numeroFinal, setNumeroFinal] = useState(numeroFilas)
  const [numerosParaMostrar, setNumerosparaMostrar] = useState([])

  const datos = useMemo(() => {
    return table.getRowModel().rows
  }, [table.getRowModel().rows])

  const crearArrayNumeros = () => {
    if (pageOptions.length > numeroFilas) {
      let numeros = pageOptions.slice(numeroInicio, numeroFinal)
      setNumerosparaMostrar(numeros)
    } else {
      setNumerosparaMostrar(pageOptions)
    }
  }
  useEffect(() => {
    crearArrayNumeros()
  }, [data, pageOptions, numeroInicio])

  const retrocederEnLista = () => {
    if (numeroInicio - numeroFilas > 0) {
      setNumeroInicio(numeroInicio - numeroFilas)
      setNumeroFinal(numeroFinal - numeroFilas)
    } else {
      setNumeroInicio(numeroFilas)
      setNumeroFinal(numeroFilas)
    }
  }
  const avanzarEnLista = () => {
    if (numeroFinal + numeroFilas < pageOptions.length) {
      setNumeroInicio(numeroInicio + numeroFilas)
      setNumeroFinal(numeroFinal + numeroFilas)
    } else {
      setNumeroInicio(pageOptions.length - numeroFilas)
      setNumeroFinal(pageOptions.length)
    }
  }

  const irAlInicio = () => {
    setNumeroInicio(0)
    setNumeroFinal(numeroFilas)
  }

  const irAlFinal = () => {
    setNumeroInicio(pageOptions.length - numeroFilas)
    setNumeroFinal(pageOptions.length)
  }

  return (
    <div className="w-full flex flex-wrap justify-center items-center ">
      <label className="w-full text-start block text-xl text-17px text-cendiatra my-5">
        {titulo}
      </label>
      <table className="w-full">
        <thead
          className={`w-full flex justify-evenly items-center ${fondoTabla} text-white h-14 rounded-10px`}
          style={{lineHeight: '16px'}}
        >
          {table.getHeaderGroups().map((headerGroup) => (
            <tr
              className="w-full flex justify-evenly items-center h-full p-3px"
              key={headerGroup.id}
            >
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className={`${
                    header.column.columnDef.meta?.className || ''
                  } h-full flex flex-wrap justify-center items-center content-center m-3px rounded-9px font-light`}
                >
                  {flexRender(
                    header.column.columnDef.header,
                    header.getContext()
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="w-full ">
          {datos.map((row, i) => {
            return (
              <tr
                className={`w-full flex ${bordeInferior} justify-evenly items-center text-center text-17px text-cendiatra-gris-1  my-5`}
                key={row.id}
              >
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td
                      key={cell.id}
                      style={{backgroundColor: 'white'}}
                      className={`${
                        cell.column.columnDef.meta?.className || ''
                      } uppercase`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div
        className={` w-full ${
          paginacion ? 'flex' : 'hidden'
        } justify-center items-center m-5 h-20 `}
      >
        <div className="flex w-8/12 justify-center items-center">
          <div className="flex">
            <button
              className="text-5xl text-cendiatra-gris-1 ml-2 relative inline-flex items-center pb-3"
              onClick={irAlInicio}
            >
              {'\u00AB'}
            </button>{' '}
            <button
              className="text-5xl text-cendiatra-gris-1 ml-2 relative inline-flex items-center pb-3 mr-3"
              onClick={retrocederEnLista}
            >
              {'\u2039'}
            </button>{' '}
            {numerosParaMostrar.map((elemento) => (
              <div
                key={elemento}
                className={
                  pageIndex === elemento
                    ? 'z-10 h-10 mt-2 bg-cendiatra border-cendiatra text-white relative inline-flex items-center px-4 border text-13px font-medium cursor-pointer rounded-full '
                    : ' h-10 mt-2 text-cendiatra-gris-1 hover:text-cendiatra-gris-3 relative inline-flex items-center px-4 border text-sm font-medium cursor-pointer rounded-full'
                }
                onClick={() => table.setPageIndex(elemento)}
              >
                {elemento + 1}
              </div>
            ))}
            <button
              className="text-5xl text-cendiatra-gris-1 relative inline-flex items-center pb-3 ml-3"
              onClick={avanzarEnLista}
              disabled={!table.getCanNextPage()}
            >
              {'\u203A'}
            </button>{' '}
            <button
              className="text-5xl text-cendiatra-gris-1 ml-2 relative inline-flex items-center pb-3"
              onClick={irAlFinal}
              disabled={!table.getCanNextPage()}
            >
              {'\u00BB'}
            </button>{' '}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TablaDinamica
